export default class {
	constructor () {
		this.stream = null
		this.mediaRecorder = null
		this.chunks = []
		this.setup()
	}

	setup () {
		const that = this
		this.getStream()
		.then(stream => {
			that.stream = stream
			that.mediaRecorder = new window.MediaRecorder(stream)
			that.mediaRecorder.ondataavailable = ev => {
				this.chunks.push(ev.data)
			}
		})
		.catch(err => {
			console.log('record start err: ' + err)
		})
		// navigator.webkitGetUserMedia({
		// 	audio: true,
		// 	video:false
		// }, stream => {
		// 	this.stream = stream
		// 	this.mediaRecorder = new window.MediaRecorder(stream)
		//
		// 	this.mediaRecorder.ondataavailable = ev => {
		// 		console.log('data', ev.data)
		// 		this.chunks.push(ev.data)
		// 	}
		// }, err => {
		// 	console.error(err);
		// })
	}

  getStream () {
	  if (!window.MediaRecorder) { return Promise.reject('MediaRecorder is not supported') }

	  // 最新版 API
	  if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
	    return navigator.mediaDevices.getUserMedia({audio: true, video: false})
	  }

	  // 以前的 API
	  const legacyGetUserMedia = navigator.getUserMedia ||
	                             navigator.webkitGetUserMedia ||
	                             navigator.mozGetUserMedia
	  if (legacyGetUserMedia) {
	    return new Promise((resolve, reject) => {
	      legacyGetUserMedia({audio: true, video: false}, resolve, reject)
	    })
	  }

	  // 不支持
	  return Promise.reject('getUserMedia is not supported')
	}

	start () {
		this.chunks = []
		this.mediaRecorder.start(500);
	}

	end () {
		this.mediaRecorder.stop();
		let blob = new window.Blob(this.chunks, { type: 'audio/wav' });
		return blob;
	}

	destroy () {
		this.chunks = null
		this.mediaRecorder = null
		this.stream.getTracks().forEach(track => track.stop())
	}
}



/** WEBPACK FOOTER **
 ** ./src/components/Common/Recorder/recorder.js
 **/